import React ,{useState, useEffect} from 'react';
import EirButton from '../eir-button/EirButton';
import { Grid } from '@material-ui/core';
import { Row, Col, Container, Card } from 'reactstrap';
import { moduleMargins ,htmlWidget} from '../../Constants';
import { isMobile, isTablet, isMobileOnly } from "react-device-detect";
import {Scrollbars} from "react-custom-scrollbars";

const EirListModule=(props)=>{ 
  const [bottomCTA] = React.useState(props.CTA);
  const [stylingCTA] = React.useState({
      backgroundColor: props.ctaBackgroundColor,
      color: props.ctaFontColor,
      borderColor: props.ctaOutlineColor,
      hover: {
          backgroundColor: props.ctaBackgroundHoverColor,
          color: props.ctaFontHoverColor,
          borderColor: props.ctaOutlineHoverColor,
      }
  })

  const [windowDimensions, setDimensions] = React.useState({ 
    height: window.innerHeight,
    width: window.innerWidth
  });
  React.useEffect(() => {
    const debouncedHandleResize = debounce(function handleResize() {
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth
      })
    }, 500)

    window.addEventListener('resize', debouncedHandleResize)

    return _ => {
      window.removeEventListener('resize', debouncedHandleResize)
    }
  });
  function debounce(fn, ms) {
    let timer
    return _ => {
      clearTimeout(timer)
      timer = setTimeout(_ => {
        timer = null
        fn.apply(this, arguments)
      }, ms)
    };
  }
  
  //console.log("zoom " + Math.round(window.devicePixelRatio * 100));

  const renderContent = (content) => {
    return { __html: content };
  }

  let leftText = (props.listAlignment == "LeftList"? true : false);

    let [marginDesktop, marginMobile] = moduleMargins(props.MarginDT, props.MarginMobile);

    let BottomCTAprops = (bottomCTA != undefined ? ({
      text : bottomCTA.text, 
      title : bottomCTA.title, 
      link : bottomCTA.link, 
      target: bottomCTA.target, 
      type : bottomCTA.type, 
      icon : bottomCTA.icon,
      buttonStyle : bottomCTA.buttonStyle, 
      buttonSize : bottomCTA.buttonSize,
      theme : bottomCTA.theme,
      videoModal : bottomCTA.VideoModal,
      outline : bottomCTA.Outline,
      styling : stylingCTA

    }) : {});

    const gridContent = props.listItem.map((item,index)=>
      <div key={index} className="list-module-grid-content" style={windowDimensions.width<600?{}:{paddingRight:"83px" }}>
        <div className="list-module-grid-index">
          <div className="list-module-grid-index-number">
            <div>{index+1}</div>
          </div>
        </div>
        <div className="list-module-grid-item">
          <div className={htmlWidget + "list-module-grid-title"} dangerouslySetInnerHTML={renderContent(item.title)}></div>
          <div className="list-module-grid-description" dangerouslySetInnerHTML={renderContent(item.description)}></div>
        </div>
      </div> 
      );
    
      function renderView({ style, ...props }) {
        return (
          <div {...props} style={{...style, overflowX:'hidden', marginRight:"-100px", marginBottom:"0px", maxHeight:"790px"}} className={"view" + (isMobile?" view-tablet":"")} />
        );
      };
    
    return(
    <div className={"eir-business-ListModule "+((!isMobileOnly) ? marginDesktop : marginMobile)}>
      <div className="list-module-container">
        {props.title!=undefined && props.title.length!=0 && <div className={htmlWidget + " list-module-title"} dangerouslySetInnerHTML={renderContent(props.title)}></div>}
        <div className="list-module-content">
          <Grid container direction={windowDimensions.width<600? (leftText?"column":"column-reverse") : (leftText?"row":"row-reverse")} className="list-module-grid-container">
            <Grid item xs={12} sm={6} zeroMinWidth className="list-module-grid-left">
              {windowDimensions.width<600?
                <div className="grid-list-mobile-content" style={{paddingRight:"15px"}}>{gridContent}</div>
                :
                <div className="grid-list-scroll-div">
                <Scrollbars className="grid-list-scroll" autoHeight autoHeightMax={790} hideTracksWhenNotNeeded
                renderView={renderView}
                renderTrackHorizontal={props => (<div {...props} style={{display:"none"}} className="track-horizontal" />)}
                renderTrackVertical={props => <div {...props} className="track-vertical"/>}
                renderThumbVertical={props => <div {...props} className="thumb-vertical"/>}
                >
                  <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"/>
                  <div style={{paddingRight:"30px"}}>
                  {gridContent}
                  </div>
                </Scrollbars>
                </div>
              }
              {bottomCTA != undefined &&
                <Container className="list-button-container">
                  <EirButton {...BottomCTAprops} ></EirButton>
                </Container>}
            </Grid>
            <Grid item xs={12} sm={6} zeroMinWidth className={"list-module-grid-right" + (!leftText?" list-module-grid-right-padding":"")}>
              <div className="grid-list-scroll">
                {
                  <div className="list-module-grid-image">
                    {windowDimensions.width<600?
                      (props.mobileBackgroundImage!= undefined && <img className="list-module-image-right" src={props.mobileBackgroundImage.path} alt={props.altText} style={!leftText?{marginBottom:"40px"}:{}} />)
                      :
                      (props.desktopBackgroundImage!= undefined && <img className="list-module-image-right" src={props.desktopBackgroundImage.path} alt={props.altText} />)
                    }
                  </div>
                }
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
    );
    
};
export default EirListModule